"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var nav_left_icon_svg_1 = __importDefault(require("res/img/nav-left-icon.svg"));
var nav_right_icon_svg_1 = __importDefault(require("res/img/nav-right-icon.svg"));
var Pager = function (_a) {
    var itemsLength = _a.itemsLength, offset = _a.offset, perPage = _a.perPage, onPrev = _a.onPrev, onNext = _a.onNext, onPage = _a.onPage;
    var totalPages = Math.ceil(itemsLength / perPage);
    var generatePages = function () {
        var pages = [];
        var _loop_1 = function (i) {
            pages.push(react_1.default.createElement("button", { type: 'button', onClick: function () { return onPage(i); }, "aria-selected": i === offset, className: 'pager__button', key: "pager_button_" + i + " ", title: "Page " + (i + 1) }, i + 1));
        };
        for (var i = 0; i < totalPages; i++) {
            _loop_1(i);
        }
        return pages;
    };
    var displayAdd = itemsLength === 0 ? 0 : 1;
    var currentPos = offset * perPage;
    var atMax = offset + 1 === totalPages;
    var displayMax = atMax && itemsLength > currentPos ? itemsLength : currentPos + perPage;
    if (itemsLength === 0) {
        currentPos = 0;
        displayMax = 0;
    }
    return (react_1.default.createElement("div", { className: 'pager flex flex-row flex-space-between' },
        react_1.default.createElement("span", { className: 'products-pager__label' },
            "Showing ",
            currentPos + displayAdd,
            " to ",
            displayMax,
            " of ",
            itemsLength),
        react_1.default.createElement("div", { className: 'pager__nav flex flex-row' },
            react_1.default.createElement("button", { type: 'button', onClick: onPrev, title: 'Previous Page', className: 'pager__button flex flex-row' },
                react_1.default.createElement("img", { src: nav_left_icon_svg_1.default, alt: 'Previous' }),
                react_1.default.createElement("span", null, "Prev")),
            generatePages(),
            react_1.default.createElement("button", { type: 'button', onClick: onNext, title: 'Next Page', className: 'pager__button flex flex-row' },
                react_1.default.createElement("span", null, "Next"),
                react_1.default.createElement("img", { src: nav_right_icon_svg_1.default, alt: 'Next' })))));
};
exports.default = Pager;
